export const haversine = (a, b) => {
  const R = 6371, toR = Math.PI / 180;
  const dLat = (b.lat - a.lat) * toR, dLon = (b.lon - a.lon) * toR;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

const length = (pts) => pts.slice(1).reduce((s, p, i) => s + haversine(pts[i], p), 0);

// Nearest neighbour + 2-opt; first point is the fixed start.
export const planRoute = (start, stops) => {
  const rest = [...stops];
  const route = [start];
  while (rest.length) {
    const last = route[route.length - 1];
    let bi = 0;
    rest.forEach((p, i) => { if (haversine(last, p) < haversine(last, rest[bi])) bi = i; });
    route.push(rest.splice(bi, 1)[0]);
  }
  let improved = true;
  while (improved) {
    improved = false;
    for (let i = 1; i < route.length - 1; i++) {
      for (let k = i + 1; k < route.length; k++) {
        const cand = [...route.slice(0, i), ...route.slice(i, k + 1).reverse(), ...route.slice(k + 1)];
        if (length(cand) + 1e-9 < length(route)) { route.splice(0, route.length, ...cand); improved = true; }
      }
    }
  }
  return { route, km: length(route) };
};

export const googleMapsUrl = (route) => {
  const f = (p) => `${p.lat},${p.lon}`;
  const pts = route.slice(0, 11);
  const wp = pts.slice(1, -1).map(f).join("|");
  return `https://www.google.com/maps/dir/?api=1&origin=${f(pts[0])}&destination=${f(pts[pts.length - 1])}${wp ? `&waypoints=${encodeURIComponent(wp)}` : ""}&travelmode=driving`;
};
